import { on } from "svelte/events";
import { unmaskElement } from "./decodeMaskedRef.ts";
import { resolveOcAuto } from "./resolveOcAuto.ts";

let body: HTMLBodyElement | null = null;

if (typeof document !== "undefined") {
  /*                                                                                  */
  body = (document.body as HTMLBodyElement | null) ?? document.querySelector("body");
}

/*                                                                    */
if (!body) {
  throw new TypeError(
    "Unable to find document.body. Global event listeners for unmasking links and resolving automatic aria labels could not be initialized.",
  );
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
["focusin", "mouseover", "touchstart"].forEach((eventName) =>
  on(body, eventName, unmaskElement, { passive: true }),
);

/**
 *
 */
on(body, "focusin", resolveOcAuto, { passive: true });
